(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oger-collection-discovery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-oger-budget]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete(link.dataset.priceMin);
    url.searchParams.delete(link.dataset.priceMax);
    if (link.dataset.budgetActive !== 'true') url.searchParams.set(link.dataset.priceMax, link.dataset.ogerBudget);
    event.preventDefault();
    window.location.assign(url.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["oger-plant-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-oger-tag-filter]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  const params = new URLSearchParams(window.location.search);
  const form = link.closest('form');
  if (form) {
    for (const filter of [...params.keys()]) if (filter.startsWith('filter.')) params.delete(filter);
    params.delete('sort_by');
    for (const [key, value] of new FormData(form)) {
      if (value === '') continue;
      if (key === 'sort_by') params.set(key, value);
      else if (key.startsWith('filter.')) params.append(key, value);
    }
  }
  params.delete('page');
  url.search = params.toString();
  event.preventDefault();
  window.location.assign(url.href);
});
document.addEventListener('toggle', (event) => {
  const group = event.target;
  if (!group.matches('.oger-plant-filters__group[open]')) return;
  document.querySelectorAll('.oger-plant-filters__group[open]').forEach((other) => { if (other !== group) other.open = false; });
}, true);
  } catch(e) { console.error(e); }
})();

})();
